
interface MessageIconSurveyProps extends React.ComponentProps<'div'> {
  submit: () => void
}

export default function MessageIconSurvey ({ submit, ...rest }: MessageIconSurveyProps) {

  return(
    <div {...rest}>
      
    </div>
  )
}